import {
  ProfileContainer,
  ProfileAvatar,
  ProfileUsername,
  UpdateProfileButton,
  MyProfileHeading,
  MyProfileSubtext,
  TestEmail,
  ChangeHistory,
} from "@root/components/styles";
import { VStack, Flex, Text, Box, Avatar } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { capitalizeWords, getRoleByRoleId } from "@root/utils/helpers";
import { USER_ROLES, USER_ROLES_ENUMS } from "@root/webConstants";
import { ChangeHistoryIcon } from "@root/assets/icons/historyIcon";
import { ROUTE_NAMES, USER_TYPES } from "@root/constants";
import { CustomButton } from "@root/components/common/button/customButton";
import { ProfileChangeHistoryDrawer } from "@root/components/common/drawer/ProfileChangeHistoryDrawer";
import { useEffect, useState } from "react";
import { useGlobalContext } from "@root/context/global-context";

export const MyProfile = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const user: any = useSelector(getLoggedInUser);
  const [isChangeHistoryOpen, setIsChangeHistoryOpen] = useState(false);
  const currentUser: any = useSelector(getLoggedInUser);
  const {
    userHistory,
    getJournlaistSubscriber,
    userSubscriber,
    setUserSubscriber,
  } = useGlobalContext();

  // Determine which company name to display
  const companyName = [
    USER_TYPES.SUBSUBSCRIBER,
    USER_TYPES.JOURNALIST,
  ].includes(currentUser?.role)
    ? userSubscriber?.companyName
    : currentUser?.companyName;

  useEffect(() => {
    if (
      user?.role == USER_TYPES.SUBSUBSCRIBER ||
      user?.role == USER_TYPES.JOURNALIST
    ) {
      getJournlaistSubscriber();
    }
  }, []);

  return (
    <ProfileContainer>
      <Box maxW="100%" mx="auto" w="100%" mb={1}>
        <Flex justify="space-between" align="center">
          <MyProfileHeading>{t("userProfile.myProfile")}</MyProfileHeading>
          {/* <CustomButton
            leftIcon={<ChangeHistoryIcon />}
            text={t("userProfile.changeHistory")}
            onClick={() => setIsChangeHistoryOpen(true)}
            isLoading={false}
            isDisabled={false}
            border={"1px solid #1819B4"}
            borderRadius="8px"
            bgColor={"transparent"}
            color={"#1819B4"}
            fontSize={"14px"}
            fontWeight={500}
            padding={"10px 20px"}
          /> */}
        </Flex>
        <MyProfileSubtext>{t("userProfile.checkYourProfile")}</MyProfileSubtext>
      </Box>
      <Flex justify="center">
        <VStack spacing={4}>
          <Avatar
            name={user?.fullName || "AA"}
            src={user?.avatar}
            boxSize={{ base: "80px", md: "120px" }}
            mb={2}
          />
          {user?.fullName && (
            <ProfileUsername>{currentUser?.fullName}</ProfileUsername>
          )}

          {/* <Text fontWeight="700" fontSize="20px">
            {capitalizeWords(getRoleByRoleId(user?.role))}
          </Text> */}
          {/* {user?.role === USER_TYPES.ADMIN && ( */}
          <TestEmail>{user?.email}</TestEmail>
          {/* )} */}

          {user?.role !== USER_TYPES.ADMIN && (
            <Text
              border={"1px solid #00A177"}
              borderRadius={"32px"}
              p={"4px 12px"}
              bgColor={"#00A1771A"}
              fontWeight={500}
              fontSize={"12px"}
              color={"#00A177"}
            >
              {t("kpecDashboard.org")} {companyName}
            </Text>
          )}

          <UpdateProfileButton
            onClick={() => {
              if (user?.role === USER_TYPES.SUPER_ADMIN) {
                navigate(ROUTE_NAMES.SUPER_ADMIN_UPDATE_PROFILE);
              } else if (user?.role === USER_TYPES.ADMIN) {
                navigate(ROUTE_NAMES.UPDATE_PROFILE);
              } else if (user?.role === USER_TYPES.JOURNALIST) {
                navigate(ROUTE_NAMES.JOURNALIST_UPDATE_PROFILE);
              } else if (
                user?.role === USER_TYPES.SUBSCRIBER ||
                user?.role === USER_TYPES.NON_SUBSCRIBER
              ) {
                navigate(ROUTE_NAMES.PLEDGE_UPDATE_PROFILE);
              } else if (user?.role === USER_TYPES.SUBSUBSCRIBER) {
                navigate(ROUTE_NAMES.PLEDGE_UPDATE_PROFILE);
              } else {
                navigate(ROUTE_NAMES.JOURNALIST_UPDATE_PROFILE); // fallback or non-subscriber
              }
            }}
          >
            {t("userProfile.updateProfile")}
          </UpdateProfileButton>
        </VStack>
      </Flex>
      <ProfileChangeHistoryDrawer
        isOpen={isChangeHistoryOpen}
        onClose={() => setIsChangeHistoryOpen(false)}
        viewHistoryChange={userHistory}
      />
    </ProfileContainer>
  );
};
